import { createAuthClient } from "better-auth/react";
import { polarClient } from "@polar-sh/better-auth/client";

const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:4000",
  plugins: [polarClient()],
});

export const { signIn, signUp, signOut, useSession, checkoutEmbed } =
  authClient;
